import Icon from "components/Icon";
import { useDarkMode } from "context/DarkModeContext";

export default function ThemeToggleButton() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return <Icon name={isDarkMode ? "sun" : "moon"} onClick={toggleDarkMode} />;
}
